import { CardGalleryItemProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: CardGalleryItemProps = {
  primaryActionProps: {
    label: 'Button',
  },
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as CardGalleryItemProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      secondaryActionProps: {
        label: 'Text link',
      },
      backgroundImageUrl:
        'https://static.wixstatic.com/media/89ea07a19c3d415e99a8a8a3c0ab1de8.jpg/v1/fill/w_343,h_343,al_c,q_80,usm_0.66_1.00_0.01/89ea07a19c3d415e99a8a8a3c0ab1de8.jpg',
    } as CardGalleryItemProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
